import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Tichete HR", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "red-darken-1",
        "prepend-icon": "mdi-plus",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogTicket = true))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("Tichet nou", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dataSource,
      "show-borders": true,
      "row-alternation-enabled": true,
      "remote-operations": true
    }, {
      stareCellTemplate: _withCtx(({ data }) => [
        _createVNode(_component_v_chip, {
          color: _ctx.stareColor(data.data.Stare),
          size: "small",
          variant: "tonal"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(data.data.Stare), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxColumn, {
          "data-field": "DataCreare",
          caption: "Data",
          "data-type": "datetime",
          format: "dd.MM.yyyy HH:mm",
          width: 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Stare",
          caption: "Stare",
          width: 140,
          "cell-template": "stareCellTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PriorityID",
          caption: "Prioritate",
          width: 110
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UserMessage",
          caption: "Mesaj"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HRMessage",
          caption: "Răspuns HR"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInchidere",
          caption: "Închis la",
          "data-type": "datetime",
          format: "dd.MM.yyyy",
          width: 120
        }),
        _createVNode(_component_DxPaging, { "page-size": 15 }),
        _createVNode(_component_DxFilterRow, { visible: true })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogTicket,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogTicket) = $event)),
      "max-width": "500",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "blue-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-ticket", -1)
                  ]))]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createTextVNode(" Tichet HR nou ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.ticketValid,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ticketValid) = $event)),
                  ref: "ticketForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.ticketForm.DocumentTypeID,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ticketForm.DocumentTypeID) = $event)),
                      items: _ctx.tipuriDoc,
                      "item-title": "Denumire",
                      "item-value": "ID",
                      label: "Tip document",
                      variant: "outlined",
                      density: "compact",
                      class: "mb-3",
                      rules: [_ctx.required],
                      loading: _ctx.loadingTipuri
                    }, null, 8, ["modelValue", "items", "rules", "loading"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.ticketForm.PriorityID,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticketForm.PriorityID) = $event)),
                      items: ['Normal', 'Urgent'],
                      label: "Prioritate",
                      variant: "outlined",
                      density: "compact",
                      class: "mb-3"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.ticketForm.UserMessage,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ticketForm.UserMessage) = $event)),
                      label: "Mesaj / Detalii",
                      variant: "outlined",
                      density: "compact",
                      rows: "3",
                      rules: [_ctx.required]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.ticketError)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ticketError), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogTicket = false))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "blue-darken-1",
                  loading: _ctx.ticketLoading,
                  disabled: !_ctx.ticketValid,
                  onClick: _ctx.submitTicket
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Trimite ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}